import { useLink } from '@/hooks/useLink'
import { useUserTracker } from '@/hooks/useUserTracker'
import { type EleDocumentResponse } from '@/shared/types'
import { type View } from '@/types/index'
import { GanttChartSquareIcon } from '@ttab/elephant-ui/icons'
import useSWR from 'swr'
import type { NewItem } from './Root'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

const BASE_URL = import.meta.env.BASE_URL || ''

export const List = ({ type, createdId, asDialog }: {
  type: View
  createdId: string | undefined
  asDialog?: boolean
}): JSX.Element | null => {
  const openPlanning = useLink('Planning')
  const [newDocuments = []] = useUserTracker<NewItem[]>(type)
  const { t } = useTranslation('shared')

  const createdDocument = newDocuments.find(({ id }) => id === createdId)

  const { data: document, error } = useSWR<EleDocumentResponse, Error>(
    createdDocument || null,
    async (createdDocument: { id: string, timestamps: number } | undefined): Promise<EleDocumentResponse> => {
      const response = await fetch(`${BASE_URL}/api/documents/${createdDocument?.id}`)
      const result = await response.json() as Promise<EleDocumentResponse>
      return result
    }
  )

  if (error) return <div>{t('errors:messages.loadFailed')}</div>
  if (!document) return null

  return (
    <div>
      <a
        href='#'
        className='flex flex-start items-center text-sm gap-2 p-2 -ml-2 rounded-sm hover:bg-gray-100'
        onClick={(evt) => {
          if (!asDialog) {
            openPlanning(evt, { id: document?.document?.uuid })
          }
        }}
      >
        <GanttChartSquareIcon strokeWidth={1.75} size={18} className='text-muted-foreground' />
        {document.document?.title}
      </a>
    </div>
  )
}
